var map = {
	"./banner-01.jpg": 35036,
	"./banner-02.jpg": 51346,
	"./blue-bg.png": 90301,
	"./book-doc-01.jpg": 29615,
	"./doctor-bg.jpg": 79927,
	"./doctor1-bg.jpg": 99781,
	"./feature-bg.jpg": 46684,
	"./feature-img.jpg": 50035,
	"./patient-bg.jpg": 83566,
	"./patient1-bg.jpg": 17473,
	"./slider-1.jpg": 85266,
	"./slider-2.jpg": 92693,
	"./slider-3.jpg": 7255,
	"./slider-4.jpg": 57109,
	"./slider-5.jpg": 7487,
	"./slider-6.jpg": 59854,
	"./slider-7.jpg": 83709,
	"./swiper-slide-img-01.jpg": 72385,
	"./swiper-slide-img-02.jpg": 23784,
	"./swiper-slide-img-03.jpg": 52626,
	"./video-slider-img-01.jpg": 76277,
	"./video-slider-img-02.jpg": 63194,
	"./video-slider-img-03.jpg": 25881,
	"./video-slider-img-04.jpg": 38502,
	"./video-slider-thumb-01.jpg": 79103,
	"./video-slider-thumb-02.jpg": 7233,
	"./video-slider-thumb-03.jpg": 94752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25531;